import React from "react";

import { DynamicForm } from "src/components/Form";

import { contactFields } from "./fields";

const fields = options => ({ t }) => [
  {
    type: "section",
    fields: [
      ...contactFields({ t, includeAccountNumber: false }),
      {
        key: "appointmentLocation",
        label: t("forms.appointment.appointmentLocationLabel"),
        placeholder: t("forms.appointment.appointmentLocationPlaceholder"),
        required: true,
        type: "dropdown",
        inputProps: {
          options,
        },
      },
    ],
  },
];

const AppointmentForm = ({ moduleKey, options }) => (
  <DynamicForm
    formKey={options.formKey || moduleKey}
    fields={fields(options.options)}
    defaultSuccessMessageKey="forms.defaultSuccessMessage"
  />
);

export default AppointmentForm;



// WEBPACK FOOTER //
// ./src/components/Content/forms/AppointmentCampaignForm.js